import React, { useEffect, useState } from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    IconButton,
    Button,
    Typography,
    Select,
    MenuItem,
    FormControl,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputLabel
} from '@mui/material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Visibility as VisibilityIcon,
    Close as CloseIcon,
    AccountBalance as AccountBalanceIcon,
    Storefront
} from '@mui/icons-material';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector
} from '@mui/x-data-grid-pro';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import axios from '../../../axios-order';
import BusinessIcon from '@mui/icons-material/Business';
import {
    Container,
    Grid
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import SelectInput from "../../../components/ui/basicSelectInput";
import InputField from "../../../components/ui/inputField";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { LoadingButton } from '@mui/lab';


const ProductMaster = () => {
    // Sample data
    const [productFormData, setProductFormData] = useState({
        gstin: '',
        product_description: "",
        is_service: "",
        hsn_code: "",
        hsn_description: "",
        unit: "",
        unit_price: "",
        gst_rate: "",
        cess_ad_rate: "",
        cess_non_adj_amt: "",
        state_cess_rate: "",
        entity_gstin: localStorage.getItem('gst'),
        branch_name: localStorage.getItem('branch_name')
    })
    const [productData, setProductData] = useState([])
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("");
    const [message, setMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState("");
    const [productDataLoading, setProductDataLoadingLoading] = useState(false)
    const [productFormDialogOpen, setProductDailogOpen] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState({})
    const [hsnDescritptionList, setHsnDescriptionList] = useState([])
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false)
    const [gstArray, setGstArray] = useState([])

    const unitOptions = [
        { id: "BAGS", unit: "BAGS" },
        { id: "BALE", unit: "BALE" },
        { id: "BUNDLES", unit: "BUNDLES" },
        { id: "BUCKLES", unit: "BUCKLES" },
        { id: "BILLION OF UNITS", unit: "BILLION OF UNITS" },
        { id: "BOX", unit: "BOX" },
        { id: "BOTTLES", unit: "BOTTLES" },
        { id: "BUNCHES", unit: "BUNCHES" },
        { id: "CANS", unit: "CANS" },
        { id: "CUBIC METERS", unit: "CUBIC METERS" },
        { id: "CUBIC CENTIMETERS", unit: "CUBIC CENTIMETERS" },
        { id: "CENTIMETERS", unit: "CENTIMETERS" },
        { id: "CARTONS", unit: "CARTONS" },
        { id: "DOZENS", unit: "DOZENS" },
        { id: "DRUMS", unit: "DRUMS" },
        { id: "GREAT GROSS", unit: "GREAT GROSS" },
        { id: "GRAMMES", unit: "GRAMMES" },
        { id: "GROSS", unit: "GROSS" },
        { id: "GROSS YARDS", unit: "GROSS YARDS" },
        { id: "KILOGRAMS", unit: "KILOGRAMS" },
        { id: "KILOLITRE", unit: "KILOLITRE" },
        { id: "KILOMETRE", unit: "KILOMETRE" },
        { id: "LITRES", unit: "LITRES" },
        { id: "MILILITRE", unit: "MILILITRE" },
        { id: "METERS", unit: "METERS" },
        { id: "METRIC TON", unit: "METRIC TON" },
        { id: "NUMBERS", unit: "NUMBERS" },
        { id: "PACKS", unit: "PACKS" },
        { id: "PIECES", unit: "PIECES" },
        { id: "PAIRS", unit: "PAIRS" },
        { id: "QUINTAL", unit: "QUINTAL" },
        { id: "ROLLS", unit: "ROLLS" },
        { id: "SETS", unit: "SETS" },
        { id: "SQUARE FEET", unit: "SQUARE FEET" },
        { id: "SQUARE METERS", unit: "SQUARE METERS" },
        { id: "SQUARE YARDS", unit: "SQUARE YARDS" },
        { id: "TABLETS", unit: "TABLETS" },
        { id: "TEN GROSS", unit: "TEN GROSS" },
        { id: "THOUSANDS", unit: "THOUSANDS" },
        { id: "TONNES", unit: "TONNES" },
        { id: "TUBES", unit: "TUBES" },
        { id: "US GALLONS", unit: "US GALLONS" },
        { id: "UNITS", unit: "UNITS" },
        { id: "YARDS", unit: "YARDS" },
        { id: "OTHERS", unit: "OTHERS" },
    ];

    const gstRateOptions = [
        { id: "0.00%", gst_rate: "0%" },
        { id: "0.10%", gst_rate: "0.1%" },
        { id: "1.00%", gst_rate: "1%" },
        { id: "3.00%", gst_rate: "3%" },
        { id: "5.00%", gst_rate: "5%" },
        { id: "12.00%", gst_rate: "12%" },
        { id: "18.00%", gst_rate: "18%" },
        { id: "28.00%", gst_rate: "28%" },
        { id: "40.00%", gst_rate: "40%" },
    ];


    const handleSnackbarOpen = (message, severity) => {
        setSnackbarSeverity(severity);
        setResponseMessage(message);
        setSnackbarOpen(true);


        // setSnackbarOpen(false);
    };


    // Function to close Snackbar
    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity(snackbarSeverity);
        setResponseMessage("");

    };


    const columns = [
        {
            field: 'product_description',
            headerName: 'Product Description',
            flex: 1, // Allows it to take available space
            minWidth: 150, // Minimum width
            align: 'left',
            filterable: true,
        },
        {
            field: 'is_service',
            headerName: 'Service Available',
            flex: 1, // Makes it flexible
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'unit',
            headerName: 'Unit',
            flex: 0.7, // Adjust the flex to be a smaller width
            minWidth: 120, // Minimum width to prevent squishing
            pinned: 'left',
            align: 'left',
            filterable: true,
        },
        {
            field: 'hsn_code',
            headerName: 'HSN/SAC',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'unit_price',
            headerName: 'Unit Price',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'gst_rate',
            headerName: 'GST Rate',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'cess_ad_rate',
            headerName: 'CESS AD RATE',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'cess_non_adj_amt',
            headerName: 'Cess NON-AD RATE',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'state_cess_rate',
            headerName: 'STATE CESS RATE',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'actions',
            headerName: 'Action',
            flex: 1, // Makes it flexible
            minWidth: 200, // Minimum width to prevent squishing
            align: 'left',
            renderCell: (params) => {
                const row = params.row;

                return (
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>

                        <IconButton
                            size="medium"
                            onClick={() => handleOpenEditDailogForm(row)}
                            title="Edit Product"
                        >
                            <EditIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>

                    </div>
                );
            },
            filterable: false,
        },
    ];


    useEffect(() => {
        getProductData()
        getGstinInfo()
    }, [])

    useEffect(() => {

        ValidatorForm.addValidationRule('checkHSNCodeWithService', (value) => {
            const isService = productFormData.is_service;
            if (isService === "Yes" && value && !value.startsWith('99')) {
                return false;
            }

            if (isService === "No" && value && value.startsWith('99')) {
                return false;
            }

            return true;
        });

        return () => {
            ValidatorForm.removeValidationRule('checkHSNCodeWithService');
        };

    }, [productFormData.is_service]);


    useEffect(() => {

        if (productFormData.hsn_code && productFormData.hsn_code.length >= 2) {
            getProductDescriptionFromHSN()
        }
    }, [productFormData.hsn_code])


    const getProductDescriptionFromHSN = () => {
        axios.get(`/einvoice/get_hsn_description/${productFormData.hsn_code}`)
            .then((res) => {
                if (res?.data?.status) {
                    const hsnDesList = res?.data?.records || []
                    setHsnDescriptionList(hsnDesList)
                } else {
                    handleSnackbarOpen(res?.data?.message, "error")
                    setHsnDescriptionList([])
                }
            }).catch((err) => {

            })
    }

    const getGstinInfo = () => {
        axios.get(`/einvoice/get_gst_info/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const gstList = res?.data?.records || []
                    if (gstList && gstList.length == 1) {
                        setProductFormData(prev => ({
                            ...prev,
                            gstin: gstList[0].gstin
                        }));

                    }
                    setGstArray(gstList)
                }
            }).catch((err) => {

            })
    }


    const handleChnageProductForm = (e) => {

        const { name, value } = e.target;
        if (name === "is_service") {
            setProductFormData({ ...productFormData, [name]: value, hsn_code: '', hsn_description:'' });
        } else {
            setProductFormData({ ...productFormData, [name]: value });
        }

    }

    const handleOpenEditDailogForm = (row) => {
        setSelectedProduct(row)
        setProductFormData({
            gstin: row.gstin,
            product_description: row.product_description,
            is_service: row.is_service,
            hsn_code: row.hsn_code,
            hsn_description: row.hsn_description,
            unit: row.unit,
            unit_price: row.unit_price,
            gst_rate: row.gst_rate,
            cess_ad_rate: row.cess_ad_rate,
            cess_non_adj_amt: row.cess_non_adj_amt,
            state_cess_rate: row.state_cess_rate,
            entity_gstin: row.entity_gstin,
            branch_name: row.branch_name
        })
        setProductDailogOpen(true)
    }

    const clearProductForm = (payLoadData) => {
        setProductFormData({
            gstin: '',
            product_description: "",
            is_service: "",
            hsn_code: "",
            hsn_description: "",
            unit: "",
            unit_price: "",
            gst_rate: "",
            cess_ad_rate: "",
            cess_non_adj_amt: "",
            state_cess_rate: "",
            entity_gstin: "",
            branch_name: ""
        })
        setHsnDescriptionList([])
    }

    const updateProduct = (payLoadData) => {
        axios.post('/e_invoice_product_update', payLoadData)
            .then((res) => {
                console.log(payLoadData);
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success');
                    handleCloseProductFormDialog();
                } else {
                    handleSnackbarOpen(res.data.message, 'error')
                }
            }).catch((err) => {
            }).finally(() => {
                setSubmitButtonLoading(false);
                getProductData();
            });
    }

    const createProduct = (payLoadData) => {
        axios.post('/e_invoice_product_create', payLoadData)
            .then((res) => {
                console.log(payLoadData);
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success');
                    handleCloseProductFormDialog();
                } else {
                    handleSnackbarOpen(res.data.message, 'error')
                }
            }).catch((err) => {
            }).finally(() => {
                setSubmitButtonLoading(false);
                getProductData();
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitButtonLoading(true);
        const payLoadData = {
            ...productFormData,
            business_entity_id: localStorage.getItem('business_entity_id'),
            common_product_id: selectedProduct.common_product_id,
            entity_gstin: localStorage.getItem('gst'),
            branch_name: localStorage.getItem('branch_name')
        };
        const hasData = selectedProduct && Object.keys(selectedProduct).length > 0;
        if (hasData) {
            updateProduct(payLoadData);
        } else {
            createProduct(payLoadData);
        }
    }

    const getProductData = () => {
        setProductDataLoadingLoading(true)
        axios.get(`/e_invoice_product_details/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const records = res?.data?.records
                    setProductData(records)
                }
            }).catch((err) => {

            }).finally(() => {
                setProductDataLoadingLoading(false)
            })
    }

    const handleOpenSupplierFormDialog = () => {
        setProductDailogOpen(true)
    }

    const handleCloseProductFormDialog = () => {
        clearProductForm()
        setProductDailogOpen(false)
        setSelectedProduct({})
    }

    const CustomToolbar = () => (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                height: '60px',
                flexWrap: 'wrap',
                gap: 1,
                padding: '3px 10px',
                backgroundColor: '#ffffff',
                borderRadius: '4px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            }}
        >
            <Box sx={{ display: 'flex', gap: 1 }}>
                <GridToolbarColumnsButton
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
                <GridToolbarFilterButton
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
                <GridToolbarDensitySelector
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
            </Box>

            <Box sx={{ display: 'flex', gap: 1, alignSelf: 'center' }}>
                <Button
                    variant="contained"
                    startIcon={<ControlPointIcon />}
                    onClick={() => handleOpenSupplierFormDialog()}
                    style={{ height: '40px', backgroundColor: '#00b0ff' }}
                >
                    Add Product
                </Button>
            </Box>
        </Box>
    );

    const AddProductDailog = () => {
        const hasData = selectedProduct && Object.keys(selectedProduct).length > 0;
        const isEditMode = hasData;
        return (

            <Container maxWidth="lg" sx={{ py: 4 }}>
                <ValidatorForm
                    useRef="form"
                    onSubmit={handleSubmit}
                    onError={(errors) => console.log(errors)}
                >
                    <Grid container spacing={5}>

                        <Grid item xs={12} sm={4} mt={1}>

                            <SelectInput
                                choice_id="gstin"
                                requiredField="*"
                                validator={["required"]}
                                errorMsg={["This field is required"]}
                                choice_name="entity_name"
                                SelectLabel="ENTITY NAME"
                                name="gstin"
                                value={productFormData.gstin}
                                textOnchangeFunction={handleChnageProductForm}
                                choices={gstArray}
                                disabled={isEditMode}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4} >
                            <label>
                                Product Description
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                label="Product Description"
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="product_description"
                                value={productFormData.product_description}
                                onChange={handleChnageProductForm}
                                inputProps={{ maxLength: 300 }}
                                validators={["required", "minStringLength:3", "maxStringLength:300"]}
                                errorMessages={[
                                    "This field is required",
                                    "Minimum 3 characters required",
                                    "Maximum 300 characters allowed"
                                ]}
                            />

                        </Grid>

                        {/* Service Available */}
                        <Grid item xs={12} sm={4} mt={1}>

                            <SelectInput
                                choice_id="is_service"
                                requiredField="*"
                                validator={["required"]}
                                errorMsg={["This field is required"]}
                                choice_name="is_service"
                                SelectLabel="Service Available"
                                name="is_service"
                                value={productFormData.is_service}
                                textOnchangeFunction={handleChnageProductForm}
                                choices={[
                                    {
                                        "id": 1,
                                        "is_service": "Yes",
                                    },
                                    {
                                        "id": 2,
                                        "is_service": "No",
                                    }
                                ]}
                                disabled={isEditMode}
                            />
                        </Grid>

                        {/* HSN/SAC */}
                        <Grid item xs={12} sm={3}>
                            <label>
                                HSN/SAC
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                label="HSN/SAC *"
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="hsn_code"
                                value={productFormData.hsn_code}
                                onChange={handleChnageProductForm}
                                inputProps={{ maxLength: 8 }}
                                onKeyPress={(e) => {
                                    if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                                }}
                                validators={["required", "matchRegexp:^[0-9]{2,8}$", "checkHSNCodeWithService"]}
                                errorMessages={[
                                    "This field is required",
                                    "HSN code must be between 2 to 8 digits",
                                    productFormData.is_service === "Yes"
                                        ? "For services, HSN code must start with 99"
                                        : "For services No, HSN code must NOT start with 99"
                                ]}
                                disabled={!productFormData.is_service || isEditMode}
                            />
                        </Grid>


                        {/* HSN Description */}
                        <Grid item xs={12} sm={3} mt={1}>
                            <SelectInput
                                choice_id="hsn_description"
                                requiredField="*"
                                validator={["required"]}
                                errorMsg={["This field is required"]}
                                choice_name="hsn_description"
                                SelectLabel="HSN Description"
                                name="hsn_description"
                                value={productFormData.hsn_description}
                                textOnchangeFunction={handleChnageProductForm}
                                choices={hsnDescritptionList}
                                disabled={!productFormData.is_service || isEditMode}
                            />
                        </Grid>

                        {/* Unit */}
                        <Grid item xs={12} sm={3} mt={1}>
                            <SelectInput
                                choice_id="id"
                                requiredField="*"
                                validator={["required"]}
                                errorMsg={["This field is required"]}
                                choice_name="unit"
                                SelectLabel="Unit"
                                name="unit"
                                value={productFormData.unit}
                                textOnchangeFunction={handleChnageProductForm}
                                choices={unitOptions}
                            />
                        </Grid>

                        {/* Unit Price */}


                        <Grid item xs={12} sm={3} >
                            <label>
                                Unit Price
                                <span style={{ color: "red" }}>*</span>:
                            </label>
                            <TextValidator
                                label="Unit Price"
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="unit_price"
                                value={productFormData.unit_price}
                                onChange={handleChnageProductForm}
                                inputProps={{ maxLength: 500 }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                            />

                        </Grid>

                        {/*                         
                        <Grid item xs={12} sm={3}>
                            <label>
                                Unit Price
                                {<span style={{ color: "red" }}>*</span>}:
                            </label>
                            <TextValidator
                                label={productFormData.is_service === "Yes" || productFormData.is_service === "No"
                                    ? "Unit Price*"
                                    : "Unit Price"}
                                // label={productFormData.is_service === "No" ? "Unit Price*" : "Unit Price*"}
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="unit_price"
                                value={productFormData.unit_price}
                                onChange={handleChnageProductForm}

                                // inputProps={{ maxLength: 8 }}
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                validator={["required"]}
                                errorMsg={["This field is required"]}
                            />
                        </Grid> */}

                        <Grid item xs={12} sm={3} mt={1}>
                            <SelectInput
                                choice_id="id"
                                // requiredField={productFormData.is_service === "No" ? "*" : ""}
                                // validator={productFormData.is_service === "No" ? ["required"] : []}
                                requiredField={"*"}
                                validator={["required"]}
                                errorMsg={["This field is required"]}
                                choice_name="gst_rate"
                                SelectLabel="GST Rate%"
                                name="gst_rate"
                                value={productFormData.gst_rate}
                                textOnchangeFunction={handleChnageProductForm}
                                choices={gstRateOptions}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <label>
                                Cess Ad Rate%
                                {/* <span style={{ color: "red" }}>*</span>: */}
                            </label>
                            <TextValidator
                                label="Cess Ad Rate%"
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="cess_ad_rate"
                                value={productFormData.cess_ad_rate}
                                onChange={handleChnageProductForm}
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                            // validators={["required", "matchRegexp:^[0-9]+(\.[0-9]{1,2})?$"]}
                            // errorMessages={["This field is required", "Please enter a valid decimal number up to two decimal places"]}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <label>
                                Cess Non-Ad Amount
                                {/* <span style={{ color: "red" }}>*</span>: */}
                            </label>
                            <TextValidator
                                label="Cess Non-Ad Amount"
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="cess_non_adj_amt"
                                value={productFormData.cess_non_adj_amt}
                                onChange={handleChnageProductForm}
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                            // validators={["required", "matchRegexp:^[0-9]+(\.[0-9]{1,2})?$"]}
                            // errorMessages={["This field is required", "Please enter a valid decimal number up to two decimal places"]}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <label>
                                State Cess Rate%
                                {/* <span style={{ color: "red" }}>*</span>: */}
                            </label>
                            <TextValidator
                                label="State Cess Rate%"
                                fullWidth
                                size="small"
                                variant="outlined"
                                name="state_cess_rate"
                                value={productFormData.state_cess_rate}
                                onChange={handleChnageProductForm}
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                            // validators={["required", "matchRegexp:^[0-9]+(\.[0-9]{1,2})?$"]}
                            // errorMessages={["This field is required", "Please enter a valid decimal number up to two decimal places"]}
                            />
                        </Grid>

                    </Grid>

                    {/* Form Buttons */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                        {!isEditMode &&
                            <Button
                                variant="outlined"
                                sx={{
                                    mr: 2,
                                    color: 'text.secondary',
                                    borderColor: 'text.secondary',
                                    '&:hover': {
                                        backgroundColor: 'action.hover',
                                        borderColor: 'text.primary',
                                    },
                                }}
                                onClick={clearProductForm}
                            >
                                Clear
                            </Button>
                        }
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            type="submit"
                            loading={submitButtonLoading}
                        >
                            Submit
                        </LoadingButton>
                    </Box>
                </ValidatorForm>
            </Container>

        );
    }

    const hasData = selectedProduct && Object.keys(selectedProduct).length > 0;

    return (
        <div>

            {/* Main Table View */}


            <Box sx={{ height: '65vh', width: '100%', marginTop: '0.8%' }}>
                <DataGridPro
                    rows={productData}
                    columns={columns}
                    loading={productDataLoading}
                    // apiRef={gridApiRef}
                    localeText={{
                        toolbarDensity: 'Size',
                        toolbarDensityLabel: 'Size',
                        toolbarDensityCompact: 'Small',
                        toolbarDensityStandard: 'Medium',
                        toolbarDensityComfortable: 'Large',
                    }}
                    sx={{
                        maxHeight: '65vh',
                        '& .MuiDataGrid-columnHeaders': {
                            // backgroundColor: '#1976d2',
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            textAlign: 'right',
                            zIndex: 1000,
                        },
                        '& .MuiDataGrid-columnHeader': {
                            position: 'relative',
                            textAlign: 'right',
                            width: '100%',
                            fontWeight: 'bold',
                            backgroundColor: '#607d8b',
                        },

                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#fff',
                        },
                        "& .MuiDataGrid-sortIcon": {
                            opacity: 'inherit !important',
                        },

                        "& .MuiDataGrid-iconButtonContainer": {
                            visibility: 'visible',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            opacity: '1 !important',
                            visibility: 'visible !important',
                            display: 'flex !important',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            '& .MuiDataGrid-columnHeader': {
                                '& .MuiDataGrid-menuIconButton': {
                                    display: 'flex !important',
                                    visibility: 'visible !important',
                                    opacity: '1 !important',
                                },
                            },
                        },
                        '& .MuiDataGrid-columnHeaderIcon': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#f9f9f9',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '8px',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#f0f0f0',
                        },
                        '& .MuiCheckbox-root': {
                            color: '#1976d2',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#d3e3fc',
                            cursor: 'pointer'
                        },


                    }}
                    pagination
                    pageSize={5}
                    pageSizeOptions={[5, 10, 25, 50]}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />

            </Box>

            <Dialog
                open={productFormDialogOpen}
                onClose={handleCloseProductFormDialog}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        boxShadow: 24,
                        px: 2,
                        py: 1,
                        marginLeft: 8,
                        bgcolor: 'background.default'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1,
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Storefront color="primary" />
                        <Typography variant="h6" fontWeight="bold">
                            {hasData ? "Edit" : "Add"} Product
                        </Typography>
                    </Box>
                    <IconButton onClick={handleCloseProductFormDialog} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>


                <DialogContent dividers sx={{ px: 3, py: 2 }}>

                    {AddProductDailog()}

                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent: 'flex-end',
                        px: 3,
                        py: 2,
                        borderTop: 1,
                        borderColor: 'divider',
                        bgcolor: 'background.default',
                    }}
                >
                    <Button onClick={handleCloseProductFormDialog} variant="outlined">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={4500}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>
        </div>
    );
};

export default ProductMaster; 